var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.4733C19.3102 12.4733 19.6175 12.5311 19.9041 12.6432C20.1907 12.7553 20.4512 12.9197 20.6705 13.1269C20.8899 13.334 21.0639 13.58 21.1827 13.8507C21.3014 14.1214 21.3625 14.4116 21.3625 14.7046C21.3625 14.9976 21.3014 15.2877 21.1827 15.5585C21.0639 15.8292 20.8899 16.0751 20.6705 16.2823C20.4512 16.4895 20.1907 16.6539 19.9041 16.766C19.6175 16.8781 19.3102 16.9358 19 16.9358C18.3734 16.9358 17.7725 16.7008 17.3295 16.2823C16.8864 15.8639 16.6375 15.2964 16.6375 14.7046C16.6375 14.1128 16.8864 13.5453 17.3295 13.1269C17.7725 12.7084 18.3734 12.4733 19 12.4733ZM19 22.0358C22.3412 22.0358 25.8625 23.5871 25.8625 24.2671V25.4358H12.1375V24.2671C12.1375 23.5871 15.6588 22.0358 19 22.0358ZM19 10.4546C16.5138 10.4546 14.5 12.3565 14.5 14.7046C14.5 17.0527 16.5138 18.9546 19 18.9546C21.4862 18.9546 23.5 17.0527 23.5 14.7046C23.5 12.3565 21.4862 10.4546 19 10.4546ZM19 20.0171C15.9963 20.0171 10 21.4408 10 24.2671V27.4546H28V24.2671C28 21.4408 22.0037 20.0171 19 20.0171Z",
    fill: "#909090"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.93064d76c941eb07d03d54a3e736a8a6.svg";
export { ForwardRef as ReactComponent };